import React from "react";
import {
	DEFAULT_AVATAR_ID,
	getAvatarOptionById,
} from "../../constants/avatarOptions";

interface UserAvatarProps {
	avatarId?: string;
	size?: number;
	className?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({
	avatarId = DEFAULT_AVATAR_ID,
	size = 32,
	className = "",
}) => {
	const avatar = getAvatarOptionById(avatarId);

	return (
		<span
			className={`user-avatar ${className}`.trim()}
			style={{
				width: `${size}px`,
				height: `${size}px`,
				backgroundImage: avatar.gradient,
			}}
			role="img"
			aria-label={avatar.label}
		>
			<span
				className="user-avatar__emoji"
				style={{ fontSize: `${Math.round(size * 0.54)}px` }}
			>
				{avatar.emoji}
			</span>
		</span>
	);
};

export default UserAvatar;
